import { PermissionArea } from './users.js';
export class PermissionService {
    constructor() {
        this.cache = {};
        this.cacheTimeout = 5 * 60 * 1000; // 5 minutes
    }
    isAdmin(user) {
        return Boolean(user.is_admin);
    }
    isSponsor(user) {
        return Boolean(user.is_sponsor);
    }
    isTechnical(user) {
        return Boolean(user.is_technical);
    }
    isBusiness(user) {
        return Boolean(user.is_business);
    }
    checkPermission(area, user) {
        const adminPermissions = [
            PermissionArea.ALLOCATION_TAB,
            PermissionArea.GLOBAL_BUDGET,
            PermissionArea.BUDGET_APPROVAL,
            PermissionArea.USER_MANAGEMENT,
            PermissionArea.ADMIN_PANEL,
            PermissionArea.ACTION_CENTER_SPONSOR_CONFIG,
            PermissionArea.ACTION_CENTER_FILTER,
            PermissionArea.DEPARTMENT_BUDGET,
            PermissionArea.DEPARTMENT_BUDGET_VIEW_ALL,
            PermissionArea.SYSTEM_CREATE,
            PermissionArea.SYSTEM_EDIT,
            PermissionArea.SYSTEM_VIEW_ALL,
            PermissionArea.SYSTEM_VIEW_DEPARTMENT,
            PermissionArea.SYSTEM_VIEW_OWNED,
        ];
        const sponsorPermissions = [
            PermissionArea.GLOBAL_BUDGET,
            PermissionArea.ACTION_CENTER_SPONSOR_CONFIG,
            PermissionArea.ACTION_CENTER_FILTER,
            PermissionArea.DEPARTMENT_BUDGET,
            PermissionArea.DEPARTMENT_BUDGET_VIEW_ALL,
            PermissionArea.SYSTEM_CREATE,
            PermissionArea.SYSTEM_EDIT,
            PermissionArea.SYSTEM_VIEW_ALL,
            PermissionArea.SYSTEM_VIEW_OWNED,
        ];
        const technicalPermissions = [
            PermissionArea.ALLOCATION_TAB,
            PermissionArea.SYSTEM_VIEW_OWNED,
            PermissionArea.SMART_RECOMMENDATIONS,
        ];
        const businessPermissions = [
            PermissionArea.SYSTEM_CREATE,
            PermissionArea.SYSTEM_EDIT,
            PermissionArea.SYSTEM_BUDGET_SET,
            PermissionArea.SYSTEM_VIEW_OWNED,
        ];
        // perms check
        if (this.isAdmin(user) && adminPermissions.includes(area)) {
            return true;
        }
        if (this.isSponsor(user) && sponsorPermissions.includes(area)) {
            return true;
        }
        if (this.isTechnical(user) && technicalPermissions.includes(area)) {
            return true;
        }
        if (this.isBusiness(user) && businessPermissions.includes(area)) {
            return true;
        }
        return false;
    }
    getCacheKey(area, user, userId) {
        return `${area}_${user.id}_${userId || 'all'}`;
    }
    isCacheValid(timestamp) {
        return Date.now() - timestamp < this.cacheTimeout;
    }
    isValid(cached) {
        return this.isCacheValid(cached.timestamp);
    }
    hasUserAccessTo(area, user, userId) {
        if (!user) {
            return false;
        }
        const targetUserId = userId || user.id;
        const targetUser = userId && userId !== user.id ? { ...user, id: userId } : user;
        const cacheKey = this.getCacheKey(area, targetUser, targetUserId);
        const cached = this.cache[cacheKey];
        if (cached && this.isValid(cached)) {
            return cached.result;
        }
        const result = this.checkPermission(area, targetUser);
        this.cache[cacheKey] = {
            result,
            timestamp: Date.now(),
        };
        return result;
    }
    clearCache() {
        this.cache = {};
    }
    clearUserCache(userId) {
        const userIdStr = userId.toString();
        const keysToDelete = Object.keys(this.cache).filter((key) => key.includes(`_${userIdStr}_`) || key.endsWith(`_${userIdStr}`));
        keysToDelete.forEach((key) => {
            delete this.cache[key];
        });
    }
}
export const permissionService = new PermissionService();
